import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import {
	DocumentRequest,
	DocumentRequestDocument,
} from '@models/document-requests';
import { Repo } from '@repos/repo.service';

@Injectable({
	providedIn: 'root',
})
export class DocumentRequestsRepo extends Repo<DocumentRequest, unknown> {
	GetCollectionPath(): string {
		return CollectionPaths.document_requests();
	}

	constructor(protected firestore: AngularFirestore) {
		super(firestore);
	}

	async createRequest(request: DocumentRequest): Promise<DocumentRequest> {
		const docRef = this.firestore.firestore
			.collection(this.GetCollectionPath())
			.doc();
		await docRef.set(request);
		return { ...request, id: docRef.id } as DocumentRequest;
	}

	async getDocumentRequestDocuments(
		requestId: string,
	): Promise<DocumentRequestDocument[]> {
		const docRef = await this.firestore.firestore
			.collection(CollectionPaths.document_requests_documents(requestId))
			.get();
		return docRef.docs.map((doc) => doc.data() as DocumentRequestDocument);
	}

	async addDocumentToRequest(
		requestId: string,
		document: DocumentRequestDocument,
	): Promise<DocumentRequestDocument> {
		const docRef = this.firestore.firestore
			.collection(CollectionPaths.document_requests_documents(requestId))
			.doc();
		await docRef.set({ ...document, assignedTo: null });
		return { ...document, id: docRef.id } as DocumentRequestDocument;
	}

	async addDocumentsToRequest(
		requestId: string,
		documents: DocumentRequestDocument[],
	): Promise<void> {
		const batch = this.firestore.firestore.batch();
		documents.forEach((document) => {
			const docRef = this.firestore.firestore
				.collection(CollectionPaths.document_requests_documents(requestId))
				.doc();
			batch.set(docRef, document);
		});
		await batch.commit();
	}
}
